<template>
  <div v-if="dataPermission.includes('CNPS_DEVICE_INVENTORY_AGENCY_CREATE')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Thêm mới kho đại lý</h1>
      <div class="btn-group float-right">
        <button type="button" class="btn font-medium btn-outline-secondary" @click="addWarehouse()">
          <i class="bx bx-save"></i> Lưu
        </button>
        <button
          type="button"
          class="btn font-medium btn-outline-secondary"
          @click="checkCloseAdd()"
        >
          <i class="bx bx-exit"></i> Hủy bỏ
        </button>
      </div>
    </div>

    <div class="card p-10 pt-15 b-t-1-869fb229">
      <ValidationObserver ref="addWarehouse" class="card-body px-20 mt-2 row">
        <form class="col-md-6">
          <!-- v-if="dataAdd.level && dataAdd.level != 'ALL'" -->

          <ValidationProvider rules="required" vid="regions" name="Vùng">
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-3 col-form-label"
                >Vùng <span style="color: red">*</span></label
              >
              <div class="col-sm-7">
                <Select2
                  v-model="dataAdd.regions"
                  :options="dataConfigRegion"
                  @change="fetchManager($event)"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <!--
          <ValidationProvider
            v-if="dataAdd.level && dataAdd.level == 'CITY'"
            rules="required"
            vid="cityCode"
            name="Tỉnh/Thành phố"
          >
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-3 col-form-label"
                >Tỉnh/Thành phố <span style="color: red">*</span></label
              >
              <div class="col-sm-7" v-if="loadingProvince">
                <b-spinner label="Loading..."></b-spinner>
              </div>
              <div class="col-sm-7" v-else>
                <Select2
                  v-model="dataAdd.cityCode"
                  :options="dataProvince"
                  @select="getNameProvince($event)"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider> -->

          <ValidationProvider rules="required|minMaxName_2" vid="name" name="Tên kho">
            <div class="form-group row" slot-scope="{ errors }">
              <label class="col-sm-3 col-form-label"
                >Tên kho <span style="color: red">*</span></label
              >
              <div class="col-sm-7">
                <input v-model.trim="dataAdd.name" type="text" class="form-control" />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="required|minMaxName_5" vid="code" name="Mã kho">
            <div class="form-group row" slot-scope="{ errors }">
              <label class="col-sm-3 col-form-label"
                >Mã kho <span style="color: red">*</span></label
              >
              <div class="col-sm-7">
                <input
                  v-model.trim="dataAdd.code"
                  type="text"
                  class="form-control"
                  :placeholder="holderCode"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="required|minMaxName_2" vid="address" name="Địa chỉ">
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-3 col-form-label"
                >Địa chỉ <span style="color: red">*</span></label
              >
              <div class="col-sm-7">
                <input
                  v-model.trim="dataAdd.address"
                  type="text"
                  class="form-control"
                  placeholder="Nhập địa chỉ"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="required" vid="managerId" name="Quản lý kho">
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-3 col-form-label"
                >Quản lý kho <span style="color: red">*</span></label
              >
              <div class="col-sm-7" v-if="loadingProvince">
                <b-spinner label="Loading..."></b-spinner>
              </div>
              <div class="col-sm-7" v-else>
                <Select2 v-model="dataAdd.managerId" :options="dataManager" />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <div class="form-group row">
            <label class="col-sm-3 col-form-label">Email đại lý</label>
            <div class="col-sm-7">
              <input
                v-model.trim="dataAdd.emailAgency"
                type="text"
                class="form-control"
                placeholder="Nhập email"
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-3 col-form-label">Mô tả</label>
            <div class="col-sm-7">
              <input
                v-model.trim="dataAdd.description"
                type="text"
                class="form-control"
                placeholder="Mô tả"
              />
            </div>
          </div>

          <div style="height: 60vh"></div>
        </form>
      </ValidationObserver>
    </div>

    <div v-if="showModalNoti">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="showModalNoti = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <img :src="srcImage" alt="icon-successs" />
                  <h2 class="f18 py-3">{{ messNoti }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="checkToActionModal(keyCheck)"
                    data-dismiss="modal"
                    v-if="keyCheck === 'accept' || keyCheck === 'back'"
                  >
                    Đồng ý
                  </button>
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="showModalNoti = false"
                    data-dismiss="modal"
                    v-if="keyCheck === 'cancel' || keyCheck === 'back'"
                  >
                    Bỏ qua
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { DeviceService } from '@/services/device.service'
  import { CommonService } from '@/services/common.service'
  import { StaffService } from '@/services/staff.service'
  import Config from '@/thirdParty/config'
  export default {
    data() {
      return {
        dataAdd: {},
        leadId: this.$route.params.leadId,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataLevel: Config.levelWarehouseCreate,
        dataType: Config.typeWarehouse,
        dataConfigRegion: [],
        dataProvince: [],
        // dataDistrict: [],
        dataManager: [],
        dataKeeper: [],
        loading: false,
        messSuccess: '',
        messErr: '',
        dataConfigMcc: [],
        showModalNoti: false,
        messNoti: '',
        srcImage: '',
        keyCheck: '',
        loadingProvince: false,
        loadingDistrict: false,
        holderCode: '',
      }
    },

    created() {
      this.getRegionsByUser()
      this.configSystem()
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },

    watch: {
      'dataAdd.regions': function () {
        this.dataConfigRegion.find(e => {
          if (e.id === this.dataAdd.regions) {
            this.holderCode = `${e.code.toUpperCase()}_X`
          }
        })
      },
      // 'dataAdd.cityCode': function () {
      //   this.dataProvince.find((e) => {
      //     if (e.id === this.dataAdd.cityCode) {
      //       this.holderCode = `${e.id.toUpperCase()}_X`
      //     }
      //   })
      // }
    },

    methods: {
      async checkCloseAdd() {
        this.keyCheck = 'back'
        this.showErr('Bạn có chắc chắn muốn huỷ bỏ thao tác không ?')
      },

      async closeAdd() {
        this.$router.push('/cat-warehouse')
      },

      configSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              this.dataConfigMcc = [{ id: '0', text: '-- -- --' }]
              data.data.businessFields.map(e => {
                this.dataConfigMcc.push({ id: e.code, text: e.name })
              })
            }
          })
          .catch(error => console.log(error))
      },

      async addWarehouse() {
        try {
          const isSuccess = await this.$refs.addWarehouse.validate()
          if (!isSuccess) {
            this.keyCheck = 'cancel'
            this.showErr('Vui lòng điền đúng thông tin !')
            return
          }
          // if (this.dataAdd.level === 'ALL') {
          //   this.dataAdd.regions = this.dataConfigRegion.map((e) => e.id)
          // } else {
          //   this.dataAdd.regions = [this.dataAdd.regions]
          // }
          // if (this.dataAdd.level !== 'CITY') {
          //   this.dataAdd.city = null
          //   this.dataAdd.cityCode = null
          // }
          this.dataAdd.regions = [this.dataAdd.regions]

          this.loading = true
          const response = await DeviceService.createWarehouseAgency(this.dataAdd)
          if (response.code === 1000) {
            this.showModalNoti = true
            this.messNoti = 'Tạo kho đại lý thành công !'
            this.keyCheck = 'accept'
            this.srcImage = require('@/assets/img/noti-success2.svg')
          } else {
            this.keyCheck = 'cancel'
            this.showErr(response.message)
          }
        } catch (error) {
          this.showErr(error.message)
        } finally {
          this.loading = false
        }
      },

      showErr(message) {
        this.showModalNoti = true
        this.messNoti = message
        this.srcImage = require('@/assets/img/noti-unsuccess2.svg')
      },

      checkToActionModal(keyCheck) {
        if (keyCheck === 'accept' || keyCheck === 'back') {
          this.showModalNoti = false
          this.closeAdd()
        }
      },

      async getRegionsByUser() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          data.data.map(e => this.dataConfigRegion.push({ id: e.id, text: e.name, code: e.code }))
        }
        // if (this.dataAdd.level !== 'CITY') {
        //   const regionListId = data.data.map((e) => e.id)
        //   this.fetchManager(regionListId)
        // }
      },

      // async getCity() {
      //   try {
      //     const data = await StaffService.getAllCity({})
      //     if (data.data.length > 0) {
      //       if (this.dataUser.adminLocations.length === 0) {
      //         data.data.forEach((e) => {
      //           this.dataProvince.push({
      //             id: e.code,
      //             text: e.name
      //           })
      //         })
      //         return
      //       }
      //       data.data.filter((e) => {
      //         this.dataUser.adminLocations.forEach((element) => {
      //           if (e.code === element) {
      //             this.dataProvince.push({
      //               id: e.code,
      //               text: e.name
      //             })
      //           }
      //         })
      //       })
      //       return
      //     }
      //     this.dataProvince = []
      //   } catch (error) {
      //     console.log(error)
      //   }
      // },

      // async queryProvince(e) {
      //   try {
      //     this.loadingProvince = true
      //     // const data = await StaffService.getProvinceRegion({ regionId: [e] })
      //     // if (data.data.length > 0) {
      //     //   this.dataProvince = data.data.map((e) => {
      //     //     return {
      //     //       id: e.code,
      //     //       text: e.name
      //     //     }
      //     //   })
      //     // } else {
      //     //   this.dataProvince = []
      //     // }
      //     this.fetchManager(e)
      //   } catch (error) {
      //     console.log(error)
      //   } finally {
      //     this.loadingProvince = false
      //   }
      // },

      async fetchManager(id) {
        try {
          this.loadingProvince = true

          const { data } = await StaffService.getTypeSaleByRegion({
            regionId: id,
            typeSale: 'SALE_ADMIN',
          })

          this.dataManager =
            data.map(e => {
              return {
                id: e.id,
                text: `${e.name} - ${e.userName}`,
              }
            }) || []
          // this.dataKeeper = data.map((e) => {
          //   return {
          //     id: e.id,
          //     text: `${e.name} - ${e.userName}`
          //   }
          // })
        } catch (e) {
          this.showErr(e?.response?.data?.message || 'Không tìm thấy quản lý kho theo vùng')
        } finally {
          this.loadingProvince = false
        }
      },

      getNameProvince(item) {
        this.dataAdd.city = item.text
      },
    },
  }
</script>

<style scoped>
  .placeholder {
    background: #f0f0f0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    font-size: 18px;
    font-family: Helvetica;
  }

  .placeholder:hover {
    background: #e0e0e0;
  }
</style>
